import styled from '@emotion/styled';

import ooyeBannerImg from '@/assets/images/ooye-banner.png';

const BannerLink = styled.a`
  display: block;
  border-radius: 5px;
  overflow: hidden;
  border: 0.29px solid #b9bbc6;

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

interface OoyeBannerProps {
  utmContent: string;
}

export function OoyeBanner({ utmContent }: OoyeBannerProps) {
  const params = new URLSearchParams();
  params.set('utm_source', 'market');
  params.set('utm_medium', 'banner');
  params.set('utm_content', utmContent);

  const url = `https://ooye.kr?${params.toString()}`;

  return (
    <BannerLink href={url} target="_blank" rel="noopener noreferrer">
      <img src={ooyeBannerImg} alt="오예 - 내가 원하는 공동구매 오예에서 다 찾아보세요!" />
    </BannerLink>
  );
}
